"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROLE_NAME = void 0;
var ROLE_NAME = {
  OWNER: 'OWNER',
  NONE: 'NONE',
  SHOOTSTA_EDITOR: 'SHOOTSTA_EDITOR',
  SHOOTSTA_SENIOR_EDITOR: 'SHOOTSTA_SENIOR_EDITOR',
  SHOOTSTA_ADMIN: 'SHOOTSTA_ADMIN',
  SHOOTSTA_AM: 'SHOOTSTA_AM',
  SHOOTSTA_TECH_SUPPORT: 'SHOOTSTA_TECH_SUPPORT'
};
exports.ROLE_NAME = ROLE_NAME;